enum PricingProviderType {
  Unknown = 0,
  UkVehicleData = 1
}

export default PricingProviderType;
